import { configureStore } from "@reduxjs/toolkit";
import MainReducer from "./slice";
export default configureStore({
  reducer: {
    main: MainReducer,
  },
});
